var map = {
	"./": 323,
	"./Prematch": 1163,
	"./Prematch.tsx": 1163,
	"./PrematchDeferred": 380,
	"./PrematchDeferred.tsx": 380,
	"./PrematchPage": 348,
	"./PrematchPage.dictionary": 349,
	"./PrematchPage.dictionary.json": 349,
	"./PrematchPage.explanation": 1165,
	"./PrematchPage.explanation.ts": 1165,
	"./PrematchPage.tsx": 348,
	"./actions": 51,
	"./actions/": 51,
	"./actions/index": 51,
	"./actions/index.ts": 51,
	"./components/Content": 1025,
	"./components/Content/": 1025,
	"./components/Content/Content": 997,
	"./components/Content/Content.tsx": 997,
	"./components/Content/index": 1025,
	"./components/Content/index.ts": 1025,
	"./components/MatchCenter": 911,
	"./components/MatchCenter/": 911,
	"./components/MatchCenter/MatchCenter": 882,
	"./components/MatchCenter/MatchCenter.module.scss": 948,
	"./components/MatchCenter/MatchCenter.tsx": 882,
	"./components/MatchCenter/index": 911,
	"./components/MatchCenter/index.ts": 911,
	"./components/Sport": 912,
	"./components/Sport/": 912,
	"./components/Sport/Sport": 949,
	"./components/Sport/Sport.module.scss": 1164,
	"./components/Sport/Sport.tsx": 949,
	"./components/Sport/Tournaments": 998,
	"./components/Sport/Tournaments/": 998,
	"./components/Sport/Tournaments/Grid": 1057,
	"./components/Sport/Tournaments/Grid.js": 1057,
	"./components/Sport/Tournaments/index": 998,
	"./components/Sport/Tournaments/index.jsx": 998,
	"./components/Sport/Unions": 999,
	"./components/Sport/Unions/": 999,
	"./components/Sport/Unions/Grid": 1001,
	"./components/Sport/Unions/Grid.js": 1001,
	"./components/Sport/Unions/Unions": 1000,
	"./components/Sport/Unions/Unions.tsx": 1000,
	"./components/Sport/Unions/UnionsVirtualizer": 1002,
	"./components/Sport/Unions/UnionsVirtualizer.tsx": 1002,
	"./components/Sport/Unions/Virtualizer": 1003,
	"./components/Sport/Unions/Virtualizer.tsx": 1003,
	"./components/Sport/Unions/index": 999,
	"./components/Sport/Unions/index.tsx": 999,
	"./components/Sport/index": 912,
	"./components/Sport/index.ts": 912,
	"./components/SportRedirect": 913,
	"./components/SportRedirect/": 913,
	"./components/SportRedirect/SportRedirect": 883,
	"./components/SportRedirect/SportRedirect.tsx": 883,
	"./components/SportRedirect/index": 913,
	"./components/SportRedirect/index.ts": 913,
	"./components/SportsGrid": 1058,
	"./components/SportsGrid/": 1058,
	"./components/SportsGrid/SportsGrid": 1067,
	"./components/SportsGrid/SportsGrid.module.scss": 1088,
	"./components/SportsGrid/SportsGrid.tsx": 1067,
	"./components/SportsGrid/components/TournamentTable/TournamentTable": 1059,
	"./components/SportsGrid/components/TournamentTable/TournamentTable.js": 1059,
	"./components/SportsGrid/index": 1058,
	"./components/SportsGrid/index.ts": 1058,
	"./index": 323,
	"./index.ts": 323,
	"./reducer": 298,
	"./reducer/": 298,
	"./reducer/entities": 221,
	"./reducer/entities.ts": 221,
	"./reducer/index": 298,
	"./reducer/index.js": 298,
	"./reducer/prematchMatches": 360,
	"./reducer/prematchMatches.js": 360,
	"./reducer/presentation": 222,
	"./reducer/presentation.ts": 222,
	"./selectors/gridEntities": 202,
	"./selectors/gridEntities.ts": 202,
	"./selectors/gridPresentation": 839,
	"./selectors/gridPresentation.ts": 839,
	"./selectors/matchGridEntities": 291,
	"./selectors/matchGridEntities.ts": 291,
	"./selectors/matchGridPresentation": 1056,
	"./selectors/matchGridPresentation.ts": 1056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1290;
module.exports = webpackContext;